import { CallApi, handleJSONResponse } from "./common";
import { NewCollaborator } from "../../../../services/collaborator/types/new-collaborator";
import { Collaborator } from "../../../../services/collaborator/types/collaborator";

const callAPI = CallApi("collaborators");

export const createCollaborator = async (
  assetId: string,
  collaborator: NewCollaborator
): Promise<Collaborator> => {
  const response = await callAPI(`/${assetId}`, "POST", collaborator);

  return await handleJSONResponse(response);
};

export const deleteCollaborator = async (
  assetId: string,
  collaboratorId: string
): Promise<{}> => {
  const response = await callAPI(`/${assetId}/${encodeURIComponent(collaboratorId)}`, "DELETE");

  return await handleJSONResponse(response);
};
